import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import Grid from '@material-ui/core/Grid';
import RichTextEditor from '../../../controls/RichTextEditor';

const styles = () => ({
    whiteBackground: {
        backgroundColor: 'white',
    },
    grey: {
        color: grey[600],
    },
});

class TextBlockDetails extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <RichTextEditor
                            markdown={this.props.field.text || ''}
                            name={this.props.field.field}
                            label="Text Block Content"
                            placeholder="Text Block Content"
                            handleChange={this.props.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="additionalInfo"
                            label="Additional Information"
                            multiline
                            fullWidth
                            rows={4}
                            className={this.props.classes.whiteBackground}
                            margin="normal"
                            variant="outlined"
                            value={this.props.field.additionalInfo}
                            onChange={this.props.handleChange}
                        />
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(TextBlockDetails);
